export default __webpack_public_path__ + "static/media/plain-sticker-os.2e27f2e4.png";